import * as React from 'react';
import { Col, ControlLabel, FormControl, FormGroup, Row } from 'react-bootstrap';
import AddressMapButton from '../../../../components/common/addressValidation/AddressMapButton';
import FormSelect from '../../../../components/common/FormSelect';
import ValidatableFormGroup from '../../../../components/common/ValidatableFormGroup';
import { Translate } from '../../../../shared/LanguageService';
import ICoordinate from '../../../map/ICoordinate';

const PhotographerFormComponentCompany = (props: any) => {
    return (
        <fieldset>
            <legend>{Translate('photographers/modal/form/legend/company')}</legend>
            <ValidatableFormGroup required validationKey="address" errors={props.errors}>
                <ControlLabel>
                    {Translate('photographers/modal/form/input-label/address')}
                </ControlLabel>
                <FormControl
                    type="text"
                    name="address"
                    value={props.user && props.user.address ? props.user.address : ''}
                    onChange={props.onChange}
                />
            </ValidatableFormGroup>
            <Row>
                <Col xs={5}>
                    <ValidatableFormGroup required validationKey="postalCode" errors={props.errors}>
                        <ControlLabel>
                            {Translate('photographers/modal/form/input-label/postal-code')}
                        </ControlLabel>
                        <FormControl
                            type="text"
                            name="postalCode"
                            value={props.user && props.user.postalCode ? props.user.postalCode : ''}
                            onChange={props.onChange}
                        />
                    </ValidatableFormGroup>
                </Col>
                <Col xs={6}>
                    <ValidatableFormGroup required validationKey="city" errors={props.errors}>
                        <ControlLabel>
                            {Translate('photographers/modal/form/input-label/city')}
                        </ControlLabel>
                        <FormControl
                            name="city"
                            type="text"
                            value={props.user && props.user.city ? props.user.city : ''}
                            onChange={props.onChange}
                        />
                    </ValidatableFormGroup>
                </Col>
                <AddressMapButton
                    addressLine={props.user && props.user.address ? props.user.address : ''}
                    onAddressLineChange={(addressLine1: string) =>
                        props.onPropertyChange('address', addressLine1)
                    }
                    postalNumber={props.user && props.user.postalCode ? props.user.postalCode : ''}
                    onPostalNumberChange={(postalNumber: string) =>
                        props.onPropertyChange('postalCode', postalNumber)
                    }
                    city={props.user && props.user.city ? props.user.city : ''}
                    onCityChange={(city: string) => props.onPropertyChange('city', city)}
                    point={
                        props.user && props.user.addressPointLocation
                            ? props.user.addressPointLocation
                            : null
                    }
                    onPointChange={(point: ICoordinate) => props.onPointChange(point)}
                    error={props.errors.address}
                />
            </Row>
            <FormGroup controlId="photographerCompany">
                <ControlLabel>
                    {Translate('photographers/modal/form/input-label/company')}
                </ControlLabel>
                <FormControl
                    type="text"
                    name="company"
                    value={props.user && props.user.company ? props.user.company : ''}
                    onChange={props.onChange}
                />
            </FormGroup>
            <ValidatableFormGroup required validationKey="organisationNumber" errors={props.errors}>
                <ControlLabel>
                    {Translate('photographers/modal/form/input-label/organisation-number')}
                </ControlLabel>
                <FormControl
                    type="text"
                    name="organisationNumber"
                    value={
                        props.user && props.user.organisationNumber
                            ? props.user.organisationNumber
                            : ''
                    }
                    error={props.errors ? props.errors.organisationNumber : ''}
                    onChange={props.onChange}
                />
            </ValidatableFormGroup>
            <ValidatableFormGroup required validationKey="regionId" errors={props.errors}>
                <ControlLabel>
                    {Translate('photographers/modal/form/select-label/region')}
                </ControlLabel>
                <FormSelect
                    name="regionId"
                    error={props.errors ? props.errors.regionId : ''}
                    value={props.user && props.user.regionId ? props.user.regionId.toString() : ''}
                    placeholder=""
                    onChange={props.onChange}
                    defaultTranslateKey="photographers/modal/form/select-label/default/select-region"
                >
                    {props.regions.map((r: any) => {
                        return (
                            <option value={r.value} key={r.value}>
                                {r.label}
                            </option>
                        );
                    })}
                </FormSelect>
            </ValidatableFormGroup>
        </fieldset>
    );
};

export default PhotographerFormComponentCompany;
